<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <!-- :rules="formRules" -->
    <el-form ref="form" :model="device" label-position="right" label-width="120px">
      <el-form-item label="设备信息" prop="name">
        <el-input type="textarea" v-html="device.msg" minlength="1" maxlength="20" placeholder="请输入设备名称"></el-input>
      </el-form-item>
      <el-form-item label="使用人" prop="deviceCode">
        <el-select v-model="useUserId" filterable placeholder="请选择使用人" :filter-method="userFilter">
          <el-option v-for="(item,i) in userFilterList" :key="i" :label="item.nickName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装位置" prop="deviceType">
        <!-- <el-input v-model="form.deviceCode" minlength="1" maxlength="12" placeholder="请输入设备编码"></el-input> -->
        <AddressSelect ref="addressSelect" @backParent='backParent' @coordinate='getCoordinate' v-model="mapSelect" :other-options-title="12121212" :default-point-des="device.addressDes">
        </AddressSelect>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()">确认</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
import AddressSelect from '@/components/common/AddressSelect'
export default {
  components: {
    AddressSelect,
  },
  props: {
    install: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      device: {
        msg: "",
        addressDes: "郑州市",
        coordinate: '',
        userId: ""
      },
      form: {
        name: "",
        deviceCode: "",
      },
      useUserId: '',
      mapSelect: [],
      formRules: {},
      userList: [],
      userFilterList: []
      // form: {
      //   name: '',
      //   deviceCode: '',
      //   location:'',
      //   remarks: '',
      //   deviceType: '',
      //   zone: '',
      //   cameraId: '',
      // },
      // formRules: {
      //   name: [
      //     {
      //       required: true,
      //       validator: this.validateDeviceName,
      //       trigger: "blur"
      //     }
      //   ],
      //   deviceCode: [{
      //     required: true,
      //     validator: this.validateDeviceCode,
      //     trigger: "blur"
      //   }],
      //   location: [{
      //     required: true,
      //     validator: this.validateLocation,
      //     trigger: "blur"
      //   }],
      //   deviceType:[{
      //    required: true,
      //     message: "请选择设备类型",
      //     trigger: ["change"] 
      //   }],
      //   zone:[{
      //     required: true,
      //     message: "请选择安装区域",
      //     trigger: ["blur"] 
      //   }]
      // },
    }
  },
  created() {
    this.getDeviceMsg()
    this.getUserList()
  },

  methods: {

    async getDeviceMsg() {
      const {
        code,
        msg,
        data
      } = await this.request.get(`/front/device/${this.install.id}`)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.device.msg = `<ul>
                          <li>设备Id：${data.id}</li>
                          <li>imei：${data.imei}</li>
                          <li v-if='${data.installTime}'>安装时间：${data.installTime?data.installTime:'无'}</li>
                          <li>设备名称：${data.name}</li>
                          <li>租户Id：${data.tenantId}</li>
                        </ul>`
    },
    async getUserList() {
      const {
        code,
        msg,
        data
      } = await this.request.get('/front/system/user/query', {
        page: 1,
        pageSize: 10000,
        order: "desc",
        sort: "createTime"
      })
      if (code != 200) {
        return this.$message.error(msg)
      }
      this.userList = data
      this.userFilterList = this.userList
    },
    cancelHandle() { //取消
      this.$emit("installCancel");
    },
    confirmHandle() {
      let par = {
        deviceId: this.install.id,
        installGps: this.device.coordinate,
        installLocation:this.device.addressDes,
        useUserId: this.useUserId
      }
      delete par.msg
      delete par.coordinate
      delete par.addressDes
      this.$emit('installConfirm', par)
    },
    userFilter(val) {
      this.useUserId = val
      if (val && val.length > 0) {
        this.userFilterList = this.userList.filter((item) => {
          if (!!~item.nickName.indexOf(val) || !!~item.nickName.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else {
        this.userFilterList = this.userList;
      }
    },
    /*  validateDeviceName(rule, value, callback) {
       if (value === ""||value === null) {
         callback(new Error("设备名不能为空"));
       } else if (value.length > 20) {
         callback(new Error("设备名长度不能超过20个字符"));
       } else if (value.length < 1) {
         callback(new Error("设备名长度不能少于1个字符"));
       } else {
         var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
         if (!reg.test(value)) {
           callback(
             new Error("设备名不合法,请输入由_或字母或汉字或数字组成！")
           );
         } else {
           callback();
         }
       }
     },
     validateDeviceCode(rule, value, callback) {
       if (value === ""||value === null) {
         callback(new Error("编码不能为空"));
       } else if (value.length > 12) {
         callback(new Error("编码长度必须为12个字符"));
       } else if (value.length < 12) {
         callback(new Error("编码长度必须为12个字符"));
       } else {
         var reg = new RegExp(/^[0-9a-zA-Z]*$/);
         if (!reg.test(value)) {
           callback(new Error("编码不合法,请输入由英文(a-z/A-Z)或数字组成的编码！"));
         } else {
           callback();
         }
       }
     },
     validateLocation(rule, value, callback) {
       if (value === ""||value === null) {
         callback(new Error("安装位置不能为空"));
       } else if (value.length > 20) {
         callback(new Error("安装位置长度不能超过20个字符"));
       } else if (value.length < 1) {
         callback(new Error("安装位置长度不能少于1个字符"));
       } else {
         var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
         if (!reg.test(value)) {
           callback(
             new Error("安装位置不合法,请输入由_或字母或汉字或数字组成！")
           );
         } else {
           callback();
         }
       }
     }, */
    //地图
    backParent(address) {
      this.device.addressDes = address;
    },
    getCoordinate(coordinate) {
      console.log(`coordinate`, coordinate)
      this.device.coordinate = coordinate;
    }
  }
};
</script>

<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
